import { render, staticRenderFns } from "./AKNotFoundMessage.vue?vue&type=template&id=3b2a7209&scoped=true&"
import script from "./AKNotFoundMessage.vue?vue&type=script&lang=js&"
export * from "./AKNotFoundMessage.vue?vue&type=script&lang=js&"
import style0 from "./AKNotFoundMessage.vue?vue&type=style&index=0&id=3b2a7209&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b2a7209",
  null
  
)

export default component.exports